import PropTypes from "prop-types";
import React from "react";
import { Button, Icon, Table, Header } from "semantic-ui-react";
import { FormatCurrency } from "num-format";
import { orderBy } from "lodash";
import UuidLookups from "../../../../../../../../../../../../components/UuidLookups";
import { prettyDate } from "../../../../../../../../../../../../services/DateTime";
import EditFeeModal from "../EditFeeModal";
import feeReadableReason from "./feeReadableReason";

function BillToBorrowerFeeTable({ fees, deleteFee }) {
  let filteredFees = fees.filter(fee => fee?.fee_type === "Bill to Borrower");
  filteredFees = orderBy(filteredFees, ["created_datetime"], ["desc"]);

  return (
    <div>
      <Header>Bill To Borrower Fees</Header>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell key="original_fee_amount">
              Original Fee Amount
            </Table.HeaderCell>
            <Table.HeaderCell key="remaining_fee">
              Fee Amount Remaining To Be Paid
            </Table.HeaderCell>
            <Table.HeaderCell key="fee_reason">Fee Reason</Table.HeaderCell>
            <Table.HeaderCell key="description">Description</Table.HeaderCell>
            <Table.HeaderCell key="created_by">Created By</Table.HeaderCell>
            <Table.HeaderCell key="created_datetime">
              Created Date
            </Table.HeaderCell>
            <Table.HeaderCell key="edit">Edit</Table.HeaderCell>
            <Table.HeaderCell key="delete">Delete</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {filteredFees.map(fee => (
            <Table.Row key={fee?.uuid}>
              <Table.Cell>
                {FormatCurrency(fee?.original_fee_amount ?? 0, false)}
              </Table.Cell>
              <Table.Cell>
                {FormatCurrency(fee?.fee_amount ?? 0, false)}
              </Table.Cell>
              <Table.Cell>{feeReadableReason(fee)}</Table.Cell>
              <Table.Cell>
                {fee?.description?.length > 10
                  ? `${fee?.description.substring(0, 10)}...`
                  : fee?.description}
              </Table.Cell>
              <Table.Cell>
                <UuidLookups lookupType="user" uuid={fee?.created_by} />
              </Table.Cell>

              <Table.Cell>
                {fee?.created_datetime
                  ? prettyDate(fee?.created_datetime)
                  : "Not Found"}
              </Table.Cell>

              <Table.Cell>
                <EditFeeModal fee={fee} />
              </Table.Cell>

              <Table.Cell>
                <Button
                  basic
                  circular
                  icon
                  onClick={() => deleteFee(fee?.uuid)}
                >
                  <Icon name="delete" />
                </Button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </div>
  );
}

BillToBorrowerFeeTable.propTypes = {
  fees: PropTypes.arrayOf(PropTypes.object).isRequired,
  deleteFee: PropTypes.func.isRequired
};

export default BillToBorrowerFeeTable;
